import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../Containers/Config/index.js';
import apiCall from '../../apiCall.js';
import { GET_SIDEBAR_CONFIGURATION, GET_SIDEBAR_CONFIGURATION_ERROR, GET_SIDEBAR_CONFIGURATION_SUCCESS } from '../../../actions.js';

function* getSidebarConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/sidebar-configurations`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_SIDEBAR_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SIDEBAR_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SIDEBAR_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchGetSidebarConfiguration() {
  yield takeEvery(GET_SIDEBAR_CONFIGURATION, getSidebarConfiguration);
}

function* getSidebarConfigurationSaga() {
  yield all([fork(watchGetSidebarConfiguration)]);
}

export default getSidebarConfigurationSaga;
